import { toast } from "react-toastify";

import { socketMessage } from "WEBSOCKET/constants";
import { ACTIONS, USER_ROLES, SESSION_STATUS, TOAST_ID } from "UTILS/Constants";
import { wsocket } from "WEBSOCKET/wsocket";
import * as log from "loglevel";
import { customerCoBrowseAction } from "CONFIG/ActionFactory";
import { postMesageToCoBrowseIframeUtility } from "UTILS/Utility";

log.setLevel("info");

export const handleMessage = (data, store) => {
  const reducerData = store.getState();
  const showCustomerCoBrowse = reducerData.CustomerCoBrowseReducer.showCustomerCoBrowse;
  const coBrowseBaseUrl = reducerData.CustomerCoBrowseReducer.coBrowseBaseUrl;
  const organiser = reducerData.RoomMetaDataReducer.roomMetaData.organiser;
  const presenterId = reducerData.RoomMetaDataReducer.roomMetaData.presenterId;
  const uniqueId = reducerData.SessionReducer.uniqueId;
  const token = reducerData.SessionReducer.sessionDetails.token;

  switch (data.action) {
    case socketMessage.subCategories.PARTICIPANT._PARTICIPANT_ARRIVED:
      store.dispatch({
        type: ACTIONS.UPDATE_PARTICIPANTS,
        participant: data.participant
      });
      break;

    case socketMessage.subCategories.PARTICIPANT._EVICT_PARTICIPANT:
      // Post End_session_without_confirmation from user's end when agent evicts user/participant from session
      if (showCustomerCoBrowse) {
        postMesageToCoBrowseIframeUtility(token, coBrowseBaseUrl);
        setTimeout(() => {
          if (presenterId == uniqueId) {
            customerCoBrowseAction.endCustomerCoBrowse();
          } else {
            customerCoBrowseAction.leaveCustomerCoBrowse(uniqueId);
          }
          store.dispatch({
            type: ACTIONS.SET_USER_EVICTED_FLAG,
            isUserEvicted: true
          });
        }, 500);
      } else {
        store.dispatch({
          type: ACTIONS.SET_USER_EVICTED_FLAG,
          isUserEvicted: true
        });
      }
      break;

    case socketMessage.subCategories.PARTICIPANT._LEFT:
      //if agent left the session
      //Post End_session_without_confirmation from presenter's end once agent left session
      if (data.participant.role === USER_ROLES.AGENT && showCustomerCoBrowse && presenterId == uniqueId){
        postMesageToCoBrowseIframeUtility(token, coBrowseBaseUrl);
        setTimeout(() => {
          customerCoBrowseAction.endCustomerCoBrowse();
        }, 500);
      }
      if (organiser === uniqueId && data.participant.role !== USER_ROLES.AGENT) {
        toast.dismiss(TOAST_ID.ADMIT + data.participant.uniqueId);
      }
      store.dispatch({
        type: ACTIONS.LOCATION.STOP_LOCATION_SHARE,
        participant: data.participant.uniqueId
      });
      store.dispatch({
        type: ACTIONS.DELETE_PARTICIPANT,
        participant: data.participant
      });

      // Evicted participants details should be set before delete participant
      if(data.isParticipantEvicted === true) {
        store.dispatch({
          type: ACTIONS.SET_EVICTED_PARTICIPANT_DETAILS,
          evictedParticipantDetails: {
            evictedParticipantName: data.participant.userName,
            uniqueId: data.participant.uniqueId
          }
        });
      }

      if (
        data.participant.uniqueId &&
        wsocket.audioAndVideoRtcPeer[data.participant.uniqueId] !== undefined
      ) {
        Object.keys(wsocket.audioAndVideoRtcPeer[data.participant.uniqueId]).map((key) => {
          wsocket.audioAndVideoRtcPeer[data.participant.uniqueId][key].dispose();
        });
        wsocket.audioAndVideoRtcPeer[data.participant.uniqueId] = undefined;
      }

      if (data.participant.role === USER_ROLES.AGENT) {
        store.dispatch({
          type: ACTIONS.SET_SESSION_STATUS,
          sessionStatus: SESSION_STATUS.CLOSING
        });
      }
      let state = store.getState();
      if(state.SessionReducer.snapshoteeId === data.participant.uniqueId
        && state.ParticipantReducer.participants
        && state.ParticipantReducer.participants.length < 2){
        store.dispatch({
          type:ACTIONS.SNAPSHOT.SHOW_SNAPSHOT,
          value: false
        });
      }
      break;

    default:
      break;
  }
};
